import { Component, Fragment, h, Prop } from '@stencil/core';
import { Article, DetailsComponents, DetailsMode, Picker } from '../utils/types';
import { EnabledDisabled } from '../../../types/types';

@Component({
  tag: 'rtr-article-details-template-no-gallery',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrArticleDetailsTemplateNoGallery {
  @Prop() article: Article;
  @Prop() picker: Picker;
  @Prop() detailsComponent: DetailsComponents;
  @Prop() scrollToCalendar: boolean;
  @Prop() showLocation: EnabledDisabled;
  @Prop() mode: DetailsMode;

  galleryEl: HTMLRtrArticleDetailsGalleryElement;
  infoEl: HTMLDivElement;
  calendarEl: HTMLRtrArticleDetailsCalendarElement;

  componentDidLoad() {
    let galleryObserver = new IntersectionObserver(this.checkGalleryVisibility);
    let headerObserver = new IntersectionObserver(this.checkInfoVisibility);
    galleryObserver.observe(this.galleryEl);
    headerObserver.observe(this.infoEl);
    if (this.scrollToCalendar) {
      this.calendarEl.scrollIntoView({ behavior: 'smooth' });
    }
  }

  checkGalleryVisibility = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.detailsComponent.onGalleryContainerVisibility(false);
      } else {
        this.detailsComponent.onGalleryContainerVisibility(true);
      }
    });
  };

  checkInfoVisibility = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.detailsComponent.onInfoContainerVisibility(true);
      } else {
        this.detailsComponent.onInfoContainerVisibility(false);
      }
    });
  };

  get showArticleLocation(): boolean {
    return this.article.location && this.showLocation === EnabledDisabled.Enabled;
  }

  get showCalendar(): boolean {
    return this.mode !== DetailsMode.OrderPage;
  }

  render() {
    return (
      <Fragment>
        <rtr-article-details-header article={this.article} detailsComponent={this.detailsComponent} />

        <div class="ADContainer">
          <rentware-spacer size="M" />

          <rtr-article-details-gallery
            ref={el => (this.galleryEl = el)}
            images={this.article.images}
            name={this.article.name}
            onShowFullGallery={this.detailsComponent.onShowFullGallery}
          />

          <div ref={el => (this.infoEl = el)} class="ADInfoTrigger">
            <rtr-article-details-options article={this.article} />

            {this.article.features && <rtr-article-details-features article={this.article} />}

            {this.showCalendar && (
              <rtr-article-details-calendar ref={el => (this.calendarEl = el)} article={this.article} picker={this.picker} detailsComponent={this.detailsComponent} />
            )}

            {this.showArticleLocation && (
              <div class="ADLocation">
                {this.showCalendar && <rentware-divider />}
                <rtr-location location={this.article.location} />
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
